import { render, staticRenderFns } from "./Violations.vue?vue&type=template&id=48fcb11f&scoped=true"
import script from "./Violations.vue?vue&type=script&lang=js"
export * from "./Violations.vue?vue&type=script&lang=js"
import style0 from "./Violations.vue?vue&type=style&index=0&id=48fcb11f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fcb11f",
  null
  
)

export default component.exports